(function() {
  'use strict';

  const mapCategories = (collections) => {
    const c = {};
    collections.forEach((title, i) => {
      c[i === 0 ? 'item_category' : `item_category_${i + 1}`] = title;
    });
    return c;
  };

  const getProductData = (trackingScript) => {
    if (!trackingScript) return null;

    try {
      const d = JSON.parse(trackingScript.textContent);
      const price = parseFloat(d.price)
      const compareAtPrice = parseFloat(d.compare_at_price)
      const discount = (compareAtPrice > price) ? parseFloat((compareAtPrice - price).toFixed(2)) : 0;

      return {
        item_id: d.item_id,
        item_sku: d.item_sku,
        item_name: d.item_name,
        price,
        discount,
        currency: d.currency,
        item_variant: d.item_variant,
        item_brand: d.item_brand,
        is_preorder: d.is_preorder,
        index: d.index,
        ...mapCategories(d.collections || []),
      };
    } catch (e) {
      return null;
    }
  };

  const wishlistTracked = new Set();

  const trackAddToWishlist = (productData) => {
    if (!productData) return;
    if (wishlistTracked.has(productData.item_id)) return;
    wishlistTracked.add(productData.item_id);

    const { item_id, item_name, currency, discount, price, item_variant, item_brand, index, ...categories } = productData;
    const item = { item_id, item_name, currency, discount, price, item_variant, item_brand, index, ...categories };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_wishlist',
      ecommerce: {
        currency: productData.currency,
        value: productData.price,
        items: [item]
      }
    });
  };

  const trackCrossSellRecommendation = (productData) => {
    if (!productData) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'crossSell_item_added',
      cust_item_name: productData.item_name,
      cust_item_id: `SKU_${productData.item_sku}`,
      cust_item_variant: 'empfehlung'
    });
  };

  const trackCrossSellBundle = (productData) => {
    if (!productData) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'crossSell_item_added',
      cust_item_name: productData.item_name,
      cust_item_id: `SKU_${productData.item_sku}`,
      cust_item_variant: 'bundle'
    });
  };

  const trackPreOrderItemAdded = (productData) => {
    if (!productData || !productData.is_preorder) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'preOrder_item_added',
      cust_item_name: productData.item_name,
      cust_item_id: `SKU_${productData.item_sku}`,
      cust_item_variant: 'preorder'
    });
  };

  const setupGridTracking = () => {
    document.addEventListener('click', (e) => {
      const card = e.target.closest('[data-grid-item]');
      if (!card) return;

      const trackingScript = card.querySelector('[data-product-tracking]');
      const data = getProductData(trackingScript);

      const wkBtn = e.target.closest('.wk-button');
      if (wkBtn && wkBtn.classList.contains('wk-selected')) trackAddToWishlist(data);

      if (e.target.closest('[data-add-to-cart]')) {
        if (card.closest('#product-recommendations')) trackCrossSellRecommendation(data);
        trackPreOrderItemAdded(data);
      }
    });
  };

  const setupPDPTracking = () => {
    if (!document.body.classList.contains('template-product')) return;

    const trackingScript = document.querySelector('product-component [data-product-tracking]');
    if (!trackingScript) return;

    document.body.addEventListener('click', (e) => {
      const productData = getProductData(trackingScript);

      const wkBtn = e.target.closest('.wk-button');
      if (wkBtn && wkBtn.classList.contains('wk-selected')) trackAddToWishlist(productData);

      if (e.target.closest('[data-add-to-cart]')) trackPreOrderItemAdded(productData);
    });
  };

  const setupBundleTracking = () => {
    const bindButton = (btn) => {
      if (btn.hasAttribute('data-tracking-bound')) return;
      btn.setAttribute('data-tracking-bound', '');
      btn.addEventListener('click', () => {
        const trackingScript = document.querySelector('product-component [data-product-tracking]');
        const productData = getProductData(trackingScript);
        trackCrossSellBundle(productData);
      });
    };

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches('.rbr-addBundleBtn-container')) bindButton(node);
          node.querySelectorAll?.('.rbr-addBundleBtn-container').forEach(bindButton);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.querySelectorAll('.rbr-addBundleBtn-container').forEach(bindButton);
  };

  const getFormName = (form) => {
    if (form?.dataset?.form) return form.dataset.form;
    const action = form.getAttribute('action') || '';
    const cls = form.className || '';
    return form.id || [action, cls].filter(Boolean).join(' ') || 'unknown';
  };

  const getFieldName = (field) => {
    const orig = field.name || field.id || field.getAttribute('placeholder') || 'unknown';
    // Try to extract a subfield, e.g., contact[name] -> name
    const match = orig.match(/^[^\[]*\[([^\]]+)\]$/);
    if (match) return match[1];
    return orig;
  };

  const setupInputTracking = () => {
    const interacted = new Set();

    document.addEventListener('change', (e) => {
      const form = e.target.closest('form');
      if (!form || !form?.dataset?.form || !form?.dataset?.trackInputs) return;

      const field = e.target;
      if (!field.matches('input, select, textarea')) return;

      const fieldName = getFieldName(field);
      if (interacted.has(fieldName)) return;
      interacted.add(fieldName);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'form_field_interaction',
        form_name: form.dataset.form,
        form_field: fieldName
      });
    });
  };

  const setupFormTracking = () => {
    const interacted = new Set();

    document.addEventListener('change', (e) => {
      const field = e.target;
      if (!field.matches('input, select, textarea')) return;
      if (!field.value) return;
      const form = field.closest('form');
      if (!form) return;

      const formName = getFormName(form);
      const fieldName = getFieldName(field);
      const key = `${formName}:${fieldName}`;
      if (interacted.has(key)) return;
      interacted.add(key);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'form_field_interaction',
        form_name: formName,
        form_field: fieldName
      });
    });

    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form.matches('form')) return;
      const formName = getFormName(form);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'form_field_completed',
        form_name: formName
      });
    });

    document.addEventListener('invalid', (e) => {
      const field = e.target;
      const form = field.closest('form');
      if (!form) return;

      const formName = getFormName(form);
      const fieldName = getFieldName(field);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'form_validation_error',
        form_name: formName,
        error_type: fieldName,
        error_message: field.validationMessage
      });
    }, true);
  };

  setupGridTracking();
  setupPDPTracking();
  setupBundleTracking();
  setupInputTracking();
  setupFormTracking();

})();
